import { z } from 'zod';
import { paraBirimi } from '../nokta/nokta.js';
export const rezervasyonDurumu = z.enum([
    'BEKLEMEDE',
    'KULLANILDI',
    'IPTAL_EDILDI',
    'SURESI_GECTI',
]);
export const rezervasyon = z.object({
    id: z.string(),
    musteriId: z.string(),
    musteriAdSoyad: z.string().nullable().optional(),
    musteriTelefon: z.string().nullable().optional(),
    noktaId: z.string(),
    noktaKod: z.string().nullable().optional(),
    noktaAd: z.string().nullable().optional(),
    dolapId: z.string(),
    dolapNumara: z.string().nullable().optional(),
    baslangicZamani: z.string().datetime(),
    sureSaat: z.number().int(),
    durum: rezervasyonDurumu,
    paraBirimi: paraBirimi,
    onOdemeTutar: z.string(),
    kiralamaId: z.string().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
});
export const rezervasyonSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
    arama: z.string().optional(),
    durum: rezervasyonDurumu.optional(),
    noktaId: z.string().optional(),
    baslangicTen: z.string().datetime().optional(),
    baslangicAKadar: z.string().datetime().optional(),
});
//# sourceMappingURL=rezervasyon.js.map